const fixedScroll = ref<boolean>(false);
export function fixAnchorScrollOnce() {
  if (fixedScroll.value) {
    return;
  }
  return nextTick(() => {
    const hash = useRoute().hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      fixedScroll.value = true;
    }
  });
}
